<template>
  <b-dropdown
    aria-role="list"
    class="account-dropdown"
    v-bind:class="dropDownPosition"
  >
    <div class="customer-icon" slot="trigger" role="button">
      <div class="svg-container">
        <svg viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11C11.17,11 10.5,10.33 10.5,9.5C10.5,8.67 11.17,8 12,8C12.83,8 13.5,8.67 13.5,9.5C13.5,10.33 12.83,11 12,11Z"
          />
        </svg>
      </div>
      <div class="customer-name">
        {{ accountName }}
        <b-tag
          size="is-small"
          v-if="isLoggedIn && unreadNotification > 0"
          rounded
          type="is-danger"
        >
          {{ unreadNotification }}
        </b-tag>
      </div>
    </div>

    <a :href="this.osvConfig.paths.account">
      <b-dropdown-item
        aria-role="listitem"
        v-if="isLoggedIn && this.osvConfig.paths.account"
      >
        <div class="media">
          <b-icon class="media-left text-grey" icon="account"></b-icon>
          <div class="media-content">
            <h3>{{ $t("account") }}</h3>
          </div>
        </div>
      </b-dropdown-item>
    </a>

    <hr class="dropdown-divider" v-if="isLoggedIn" />

    <b-dropdown-item aria-role="listitem" v-if="isLoggedIn" @click="logout">
      <div class="media">
        <b-icon class="media-left text-danger" icon="power"></b-icon>
        <div class="media-content">
          <h3 class="text-danger">
            {{ $t("logout") }}
          </h3>
        </div>
      </div>
    </b-dropdown-item>

    <a :href="this.osvConfig.paths.signIn">
      <b-dropdown-item
        aria-role="listitem"
        v-if="!isLoggedIn && this.osvConfig.paths.signIn"
      >
        <div class="media">
          <b-icon class="media-left text-grey" icon="lock-open"></b-icon>
          <div class="media-content">
            <h3>
              {{ $t("login") }}
            </h3>
          </div>
        </div>
      </b-dropdown-item>
    </a>

    <a :href="this.osvConfig.paths.signUp">
      <b-dropdown-item
        aria-role="listitem"
        v-if="!isLoggedIn && this.osvConfig.paths.signUp"
      >
        <div class="media">
          <b-icon class="media-left text-grey" icon="account-plus"></b-icon>
          <div class="media-content">
            <h3>
              {{ $t("signIn") }}
            </h3>
          </div>
        </div>
      </b-dropdown-item>
    </a>
  </b-dropdown>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { ConfigMixin } from "@/mixins/ConfigMixin";
import store from "@/store";
import VueI18n from "vue-i18n";
import cug from "@/services/cug";

export default {
  store,
  name: "AccountIcon",
  mixins: [LocaleMixin, ConfigMixin],
  props: {
    dropDownPosition: {
      type: String,
      required: false,
      default: "is-right"
    }
  },

  mounted() {
    this.$i18n.locale = this.getLocale();
    this.getUnreadNotification();

    this.$root.$on('refreshUnreadNotificationAccountIcon', () => {
      this.getUnreadNotification();
    })
  },

  beforeDestroy() {
    this.$root.$off('refreshUnreadNotificationAccountIcon')
  },

  computed: {
    isLoggedIn: function() {
      return store.getters["auth/isLoggedIn"];
    },

    accountName: function() {
      return store.getters["auth/getName"];
    },

    unreadNotification: function() {
      return store.getters["notification/getUnreadNotification"];
    },
  },

  methods: {
    logout: function() {
      store.dispatch("auth/logout");
    },

    getUnreadNotification: function () {
      if (this.isLoggedIn) {
        cug
          .countUnreadNotifications()
          .then(resp => {
            store.dispatch('notification/setUnreadNotification', resp.data);
          });
      }
    },
  },

  // Translate component
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        account: "My account",
        logout: "Logout",
        login: "Login",
        signIn: "Sign in"
      },
      fr: {
        account: "Mon compte",
        logout: "Déconnexion",
        login: "Me connecter",
        signIn: "Créer un compte"
      }
    }
  })
};
</script>

<style lang="scss" src="../assets/styles/buefy/base.scss" />
<style lang="scss">
.customer-icon {
  display: inline-block;
  color: inherit;
  cursor: pointer;
  transition: opacity 0.3s;
  &:hover {
    opacity: 0.7;
  }
  .svg-container {
    display: inline-block;
    height: 2rem;
    vertical-align: middle;
    svg {
      height: 100%;
    }
  }
  .customer-name {
    color: inherit;
    display: inline;
  }
}
.account-dropdown {
  a {
    color: black;
  }
}
</style>
